import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

import CleartripLogo from "../../assets/svg/ctLogo";
import { CirclesThreePlus } from "phosphor-react";
import { TeamSelector } from "../TeamSelector";

export const SideNav = () => {
    const navigate = useNavigate()
    const location = useLocation()

    return (
        <div className="flex flex-col gap-2 h-full">
            <div className="shadow-[0_20px_20px_-20px_rgba(0,0,0,0.2)]" >
                <div className="px-[21px] py-[14px] flex gap-2 items-center">
                    <CleartripLogo />
                    <span className="text-xl font-medium">
                        Benefit Engine
                    </span>
                </div>
            </div>
            <ul className="menu rounded-box">
                <li>
                    <details open>
                        <summary className=" hover:bg-accent">
                            <div className="flex gap-2 items-center">
                                <CirclesThreePlus color="#16A34A" width={24} height={24} />  <p className="text-base font-normal">Intent Capture</p>
                            </div>
                        </summary>
                        <ul>
                            <li
                                className={`p-2 text-sm rounded-md transition duration-150 cursor-pointer
                                ${location.pathname.includes('/campaigns') ? 'bg-primary text-neutral' : 'hover:bg-accent'}`}
                                onClick={(evt) => {
                                    evt?.stopPropagation()
                                    navigate("campaigns")
                                }}>
                                Campaign Management
                            </li>
                            <li
                                className={`p-2 mt-2 text-sm rounded-md transition duration-150 cursor-pointer
                                ${location.pathname.includes('/rules') ? 'bg-primary text-neutral' : 'hover:bg-accent'}`}
                                onClick={(evt) => {
                                    evt?.stopPropagation()
                                    navigate("rules")
                                }}>
                                Rule Management
                            </li>
                        </ul>
                    </details>
                </li>
            </ul>
            <div className="mt-auto mb-4">
                <TeamSelector />
            </div>
        </div>
    )
}